export enum SlideoverVariant {
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
}

type SlideoverConfigBase = {
  firstSelectionOnLastItem?: boolean;
  variant?: SlideoverVariant;
  skipGuardConfirm?: boolean;
};

export type SlideoverConfig =
  | (SlideoverConfigBase & {
      blocking?: false;
    })
  | (SlideoverConfigBase & {
      blocking?: true;
      onClose?: () => void;
    });
